import Vue from 'vue';
import axios from "axios";
import router from '@/router'
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    if (!!JwtService.getToken()) {
      Vue.axios.defaults.headers.common[
        "Authorization"
      ] = `Token ${JwtService.getToken()}`;
    }
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`)/*.catch(error => {
      throw new Error(`[RWV] ApiService ${error}`)
    });*/
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}/`, params);
  },

  update_special(resource, params) {
    return Vue.axios.put(`${resource}/`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const LoginService = {
  login(params) {
    return ApiService.post('/login/', {
      username: params['username'],
      password: params['password']
    })
  },
  getLogin() {
    ApiService.setHeader();
    return ApiService.get('/login')
  },  
}


export const HomeService = {

  fetchIses() {
    return ApiService.get('ies/web/ies')
  },
  fetchValidPeriods() {
    return ApiService.get('period/web/valid_periods')
  },
  fetchCatIndicadores() {
    return ApiService.get('indicators/catalogo')
  },
  fetchCatPobs() {
    return ApiService.get('/segment/catalogo')
  },
  fetchCatTiposPob() {
    return ApiService.get('/segment/catalogo/tipo_grupo_segmento')
  },
  fetchIndicadorValues(year) {
    let forced_year = year ? `${year}/` : ''
    return ApiService.get(`period/web/${forced_year}indicador_values`)
  },
  fetchPoblations(year) {
    if (year)
      return ApiService.get('period/web/grupo_poblacion', `?year=${year}`)
    else
      return ApiService.get('period/web/grupo_poblacion')
  },
  getAxis(axis_id) {
    //return ApiService.get('ies/web/ies')
    return ApiService.get(`/indicators/catalogo/eje/${axis_id}`)
  },
  getIes(ies_id, query_params) {
    return ApiService.get(`ies/web/ies/${ies_id}`, query_params)
    //return ApiService.get(`/indicators/${axis_id}`)
  },
  generateExcel(year) {
    return ApiService.post(`inquests/${year}/export/`)
    //return ApiService.get(`/indicators/${axis_id}`)
  },

}

export const DashboardService = {

  fetchStatusRespuesta() {
    ApiService.setHeader();
    return ApiService.get('/inquests/status_respuestas')
  },
  fetchStatusIes() {
    ApiService.setHeader();
    return ApiService.get('/period/status_ies')
  },
  fetchPeriods() {
    ApiService.setHeader();
    return ApiService.get('/period')
  },
  getPeriod(period_id, stage){
    ApiService.setHeader();
    return ApiService.get(`period/${period_id}/${stage}`)
  },

  fetchPeriodIesData(period_ies_id) {
    ApiService.setHeader();    
    return ApiService.get(`/ies/period/${period_ies_id}`)
  },
  getIesData(ies_id) {
    ApiService.setHeader();
    return ApiService.get(`/ies/${ies_id}`)
  },
  updateLogo({university_id, data}) {    
    ApiService.setHeader();
    return ApiService.update('ies', university_id, data)
  },  
  updatePeriodIesData({data, period_ies_id}){
    ApiService.setHeader();
    return ApiService.update(`/ies/period`, period_ies_id, data)
  },
  updateAnswer({data, answer_id}){
    ApiService.setHeader();
    return ApiService.update(`/ies/respuesta`, answer_id, data)
  },
  updateNote({data, answer_id}){
    ApiService.setHeader();
    return ApiService.update_special(`/ies/respuesta/${answer_id}/notas`, data)
  },

  // /ies/period/:ies_period_id/grupo_poblacion/:grupo_segmento_id/
  updateGrupoSegmento({data, grupo_segmento_id}){
    ApiService.setHeader();
    let period_ies_id = router.currentRoute.params.period_ies_id
    return ApiService.update(`/ies/period/${period_ies_id}/grupo_poblacion`, grupo_segmento_id, data)
  },
  //  /ies/respuesta/:answer_id/
  usePreviousResponse({answer_id}){
    ApiService.setHeader();
    return ApiService.post(`/ies/respuesta/${answer_id}/load_previous_response/`, {})
  },
  // /ies/respuesta/:answer_id/load_previous_response/
  postNewFile({data, answer_id}){
    ApiService.setHeader();
    return ApiService.post(`/ies/respuesta/${answer_id}/archivo/`,data)
  },
  deleteFile({file_id, answer_id}){
    ApiService.setHeader();
    return ApiService.delete(`/ies/respuesta/${answer_id}/archivo/${file_id}`)
  },




}